/**
 * 热度展示组件（营销「确实很火」，但数字真实、且不挡人）：
 *  - HeatBadge：社交证明数字（今日 / 累计 / 在线），放 Hero 深色区
 *  - PeakNotice：高峰保护文案条，仅 heat / queue 档展示，放结果区上方
 */
import { usePulse, heatCopy } from '@/lib/pulse'

/** Hero 深色区内的热度徽章（数据不足时不展示，避免翻车） */
export function HeatBadge() {
  const pulse = usePulse()
  const copy = pulse ? heatCopy(pulse.stats) : null
  if (!copy) return null

  return (
    <div className="mb-4 inline-flex max-w-full flex-wrap items-center gap-x-2.5 gap-y-1 rounded-2xl border border-white/15 bg-white/10 px-3.5 py-2 text-[12.5px] text-white/90 backdrop-blur-sm">
      <span className="whitespace-nowrap font-medium text-white">
        <span className="mr-1" aria-hidden="true">🔥</span>
        {copy.volume}
      </span>
      {copy.online && (
        <span className="flex items-center gap-1 whitespace-nowrap text-accent-300">
          <span className="inline-block h-1.5 w-1.5 rounded-full bg-accent-400 animate-pulse" />
          {copy.online}
        </span>
      )}
    </div>
  )
}

/**
 * 高峰保护提示条：已按运营要求取消「当前访问较多 / 高峰保护」文案，组件保留为占位空实现，
 * 便于将来需要时一键恢复（恢复时改回按 heat / queue 档展示即可）。
 */
export function PeakNotice() {
  return null
}
